import type { ICPMultiselectItemTypes } from '~/portal/components/base'

export enum ECP_FORM_INVOICE_MODES {
  Create = 'create',
  Cancel = 'cancel',
}

export enum ECP_INVOICE_TYPE {
  Prepayment = 'Vorauszahlung',
  MainPayment = 'Hauptzahlung',
  AdditionalPayment = 'Zusätzliche Zahlung',
}

export interface ICPFormInvoiceFormData {
  [key: string]: string | number | null | undefined | ICPMultiselectItemTypes[]
  invoiceNumber: string | undefined
  customerProjectNumber: string | undefined
  invoiceType: ECP_INVOICE_TYPE | null
  additionalService?: string
  deliveryDate: string | undefined
  thirdProductPrice: number | undefined
  services?: ICPMultiselectItemTypes[]
}

export interface ICPFormInvoicePropTypes {
  modelValue: ICPFormInvoiceFormData
  disabled?: boolean
  mode?: ECP_FORM_INVOICE_MODES
  services?: ICPMultiselectItemTypes[]
}
